
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Punetosanglicab() {



  const cardData =
  {
    keyword: ' Pune to Sangli Cab',
    heading: 'SHREE Tours & Travels: Pune to Sangli Cab',
    headingDescription: 'SHREE Tours & Travels offers a dependable Pune to Sangli Cab service, ensuring a smooth and comfortable journey for travelers. Whether you are visiting Sangli for business, family, or leisure, our well-maintained Cabs and professional drivers provide a hassle-free experience. Enjoy a safe and convenient ride with flexible booking options and affordable fares. Choose SHREE Tours & Travels for a stress-free Pune to Sangli travel experience.',

    top: 'Top Places to Visit in Sangli with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Ganapati Temple",
        "description": "The Sangli Ganapati Temple is a revered spiritual site dedicated to Lord Ganesha. Known for its intricate architecture and religious significance, it attracts devotees seeking blessings and tranquility."
    },
    {
        "title": "Sangli Fort",
        "description": "A historical landmark, Sangli Fort houses government buildings and a museum showcasing artifacts from the Maratha era. The fort’s architecture and historical significance make it a must-visit for history enthusiasts."
    },
    {
        "title": "Dandoba Hills",
        "description": "A scenic trekking destination, Dandoba Hills offers lush greenery, historical ruins and breathtaking views. It is an ideal spot for adventure seekers and nature lovers looking for a peaceful retreat."
    },
    {
        "title": "Sagareshwar Wildlife Sanctuary",
        "description": "A man-made sanctuary, Sagareshwar Wildlife Sanctuary is home to deer, peacocks and other wildlife. It also features ancient temples and is a great place for trekking and nature walks."
    },
    {
        "title": "Krishna River Ghat",
        "description": "The Krishna River Ghat in Sangli is a serene spot for relaxation and spiritual rituals. The beautiful riverbank is a perfect place for evening strolls and enjoying the peaceful surroundings."
    },
    {
        "title": "Irwin Bridge",
        "description": "A colonial-era architectural marvel, Irwin Bridge spans the Krishna River, offering stunning views and a glimpse into Sangli’s historical past. It is a favorite spot for photography enthusiasts."
    },
    {
        "title": "Vishrambag Wada",
        "description": "A heritage site, Vishrambag Wada is a fine example of Maratha-era architecture. Visitors can admire its intricate woodwork and historical significance while exploring the rich legacy of Sangli."
    },
    {
        "title": "Yashwantrao Chavan Art Gallery",
        "description": "A cultural hub showcasing local and contemporary art, Yashwantrao Chavan Art Gallery is a must-visit for art lovers. It regularly hosts exhibitions and art events celebrating the region’s artistic talent."
    },
    {
        "title": "Battis Shirala",
        "description": "Famous for its annual Nag Panchami festival, Battis Shirala is a village known for its unique tradition of worshiping live snakes. It offers a fascinating cultural experience for visitors."
    },
    {
        "title": "Sangli Market",
        "description": "A bustling local market known for Sangli’s famous turmeric, spices and textiles. Visitors can shop for fresh produce, traditional goods and experience the vibrant local culture."
    }
],  
    
            
"services": [
    {
      "name": "Pune to Sangli Taxi",
      "description": "Travel comfortably with SHREE Tours & Travels by booking a taxi from Pune to Sangli. Our well-maintained fleet, including sedans, SUVs and luxury cars, ensures a smooth and hassle-free journey with experienced drivers at competitive rates. Enjoy your journey with the flexibility of customized pickup and drop-off locations."
    },
    {
      "name": "Pune to Sangli Cab Service",
      "description": "Looking for a reliable Cab service from Pune to Sangli? SHREE Tours & Travels offers one-way and round-trip Cab options with comfortable seating and professional drivers. We ensure a stress-free, comfortable ride, whether it's a short trip or a multi-day visit."
    },
    {
      "name": "Pune to Sangli One-Way Taxi",
      "description": "Need a one-way taxi from Pune to Sangli? Choose SHREE Tours & Travels for an affordable, convenient ride. Our one-way service is perfect for those looking to travel without the hassle of a round trip, with transparent pricing and no hidden charges."
    },
    {
      "name": "Pune to Sangli Round Trip Cab",
      "description": "Planning a round-trip to Sangli? Our round-trip Cab service offers flexibility with pick-up and return times tailored to your schedule. Enjoy a comfortable and well-maintained vehicle with professional drivers, ensuring a pleasant journey both ways."
    },
    {
      "name": "Affordable Pune to Sangli Cab",
      "description": "Get budget-friendly Cab services from Pune to Sangli without compromising on quality. Our affordable pricing ensures that you get reliable service with comfort and convenience, so you can travel stress-free with your choice of vehicle."
    },
    {
      "name": "Private Taxi for Sangli from Pune",
      "description": "Book a private taxi from Pune to Sangli for a personalized travel experience. Whether you're traveling solo, with family, or for business, enjoy privacy, comfort and flexibility with our private taxi service. Our professional drivers ensure you have a safe and smooth journey."
    },
    {
      "name": "Sangli Tour from Pune by Cab",
      "description": "Planning a tour to Sangli from Pune? Our Cab service makes it easy for you to enjoy a comfortable and hassle-free trip. Take a relaxing journey with experienced drivers and explore the best of Sangli's attractions, temples and historical sites."
    },
    {
      "name": "Sangli Cab Hire",
      "description": "Hire a Cab from Pune to Sangli with SHREE Tours & Travels. We offer a wide range of vehicles, including sedans, SUVs and larger vehicles for group travel. Choose the best fit for your needs and enjoy a reliable, comfortable ride."
    },
    {
      "name": "Group Travel from Pune to Sangli",
      "description": "Traveling with a group? We offer spacious vehicles, such as SUVs and tempo travelers, to ensure a comfortable journey from Pune to Sangli. Whether it's a family trip or a group tour, we provide safe, enjoyable travel with room for everyone."
    },
    {
      "name": "Book Pune to Sangli Car",
      "description": "Rent a car for your Pune to Sangli journey with SHREE Tours & Travels. Choose from a variety of vehicles to suit your needs, from budget-friendly sedans to spacious SUVs and enjoy a smooth and comfortable ride throughout your journey."
    },
    {
      "name": "Sangli Cab Booking from Pune",
      "description": "Book a Cab easily from Pune to Sangli with SHREE Tours & Travels. Our reliable online booking system ensures timely pickups and professional service at affordable rates. Enjoy the convenience of easy booking, safe travel and excellent customer support."
    },
    {
      "name": "Pune to Sangli Road Trip",
      "description": "Enjoy a scenic road trip from Pune to Sangli with our comfortable and reliable Cab service. Our experienced drivers will guide you along the best routes, ensuring you have a smooth and pleasant journey, with the opportunity to stop at notable points along the way."
    },
    {
      "name": "Sangli Temple Tour by Cab",
      "description": "Explore the famous temples of Sangli with our guided temple tour by Cab. Visit iconic religious sites like the Ganapati Temple, Bhagwan Shri Mahavir Temple and more, with the convenience of a professional driver who will guide you through the best spiritual spots in Sangli."
    },
    {
      "name": "Luxury Cab for Pune to Sangli",
      "description": "For those seeking a luxurious travel experience, we offer a premium Cab service from Pune to Sangli. Choose from high-end vehicles like Innova Crysta, Mercedes, or luxury sedans and enjoy a first-class ride with top-tier comfort and professional drivers."
    },
    {
      "name": "Affordable Sangli Cab Rental",
      "description": "Looking for a budget-friendly Cab rental for your trip from Pune to Sangli? We offer economical yet reliable rental services that provide great value for money. Choose from a variety of vehicles and enjoy comfort and convenience on your journey."
    },
    {
      "name": "Pune to Sangli Travel Package",
      "description": "Book our all-in-one travel package from Pune to Sangli for a comprehensive experience. The package includes comfortable transport, experienced drivers and optional sightseeing tours to explore the best of Sangli's attractions, temples and landmarks."
    },
    {
      "name": "Sangli Sightseeing Cab",
      "description": "Take a sightseeing tour of Sangli with our comfortable and convenient Cab service. Visit popular attractions, including historical sites and temples, with the help of an experienced driver who will guide you through the city’s must-see spots."
    },
    {
      "name": "Pune to Sangli Weekend Trip",
      "description": "Escape to Sangli for a relaxing weekend getaway from Pune. Our weekend trip packages offer comfortable Cabs, professional drivers and flexibility to explore Sangli's beauty at your own pace. Book a hassle-free trip for a peaceful and enjoyable weekend."
    }
  ],

  "tableData": [
    ["- Pune to Sangli Taxi", "- Pune to Sangli Cab Service"],
    ["- Pune to Sangli One-Way Taxi", "- Pune to Sangli Round Trip Cab"],
    ["- Affordable Pune to Sangli Cab", "- Private Taxi for Sangli from Pune"],
    ["- Sangli Tour from Pune by Cab", "- Sangli Cab Hire"],
    ["- Group Travel from Pune to Sangli", "- Book Pune to Sangli Car"],
    ["- Sangli Cab Booking from Pune", "- Pune to Sangli Road Trip"],
    ["- Sangli Temple Tour by Cab", "- Luxury Cab for Pune to Sangli"],
    ["- Affordable Sangli Cab Rental", "- Pune to Sangli Travel Package"],
    ["- Sangli Sightseeing Cab", "- Pune to Sangli Weekend Trip"]
  ],

  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable Journey",
      "WhyChoosedescription": "Our Pune to Sangli Cabs are designed to provide you with a comfortable and relaxing experience throughout your journey. With spacious seating, air-conditioning and well-maintained interiors, you can enjoy a smooth and hassle-free ride. Whether you're traveling alone or with family, our vehicles ensure a pleasant journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our drivers are experienced and knowledgeable about the Pune to Sangli route. They ensure a safe, timely and efficient trip, making use of the best routes to avoid traffic. With a focus on customer safety and comfort, our drivers make your journey stress-free and enjoyable."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer affordable and competitive pricing for your Pune to Sangli Cab ride. With transparent pricing and no hidden charges, you can rely on us for great value without compromising on service quality. Whether you're booking a one-way or round trip, we offer budget-friendly options that suit your needs."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "We ensure that all our vehicles are well-maintained and thoroughly inspected before every trip. Regular servicing ensures the safety, reliability and comfort of our fleet. From clean interiors to smooth driving performance, you can trust our vehicles for a safe and pleasant ride."
    },
    {
      "WhyChooseheading": "Flexible Rental Options",
      "WhyChoosedescription": "We provide flexible rental packages to meet your needs for the Pune to Sangli journey. Whether you need a Cab for a few hours, a full day, or multiple days, we can customize the rental to match your travel plans. Choose the option that works best for you and enjoy a personalized service."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a Cab from Pune to Sangli with us is quick and easy. You can make a reservation through our user-friendly online platform or get in touch with our customer service team for assistance. Whether you need a last-minute booking or planning ahead, our booking process is hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Pune to Sangli Cab needs. No matter when you need to travel, we’re ready to serve you. Whether it's an early morning trip or a late-night ride, we are here to ensure you have reliable transportation at any time of day."
    },
    {
      "WhyChooseheading": "Local Insights",
      "WhyChoosedescription": "Our drivers have extensive local knowledge of the Pune to Sangli route and can provide valuable insights into the area. If you’re interested in sightseeing or want recommendations for local spots along the way, our drivers are happy to share their expertise and enhance your journey."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we prioritize customer satisfaction. We are committed to delivering excellent service with a focus on comfort, safety and reliability. Our goal is to ensure that your Pune to Sangli trip is smooth and enjoyable and we guarantee a hassle-free experience every time."
    }
  ]
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Pune to Sangli?",
        answer: "You can easily book your Pune to Sangli Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Pune to Sangli route?",
        answer: "We offer a variety of vehicles for the Pune to Sangli journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Pune to Sangli inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Pune to Sangli?",
        answer: "Yes, we offer one-way rental options for your Pune to Sangli trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Pune to Sangli trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Pune to Sangli Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Pune to Sangli Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Pune to Sangli trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Pune to Sangli?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Pune to Sangli?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Pune to Sangli trip was very comfortable and hassle-free. The driver was very polite and the vehicle was in perfect condition.',
        name: 'Mr. Vijay Kulkarni',
    },
    {
        text: 'SHREE Tours & Travels made my Pune to Sangli trip easy and pleasant. The driver was professional and I felt very safe throughout the journey.',
        name: 'Miss. Shweta Rao',
    }
];





  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Cab from Pune to Sangli with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/pune-to-sangli-cab.jpg",
    "https://shreetoursandtravels.in/img/sangli-tour-cab.jpg"
  ],
  "priceRange": "₹2500 - ₹6000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/pune-to-sangli-cab-service",
    "priceCurrency": "INR",
    "price": 3000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.8,
    "reviewCount": 1500
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Sandeep Yadav"
      },
      "datePublished": "2024-07-10",
      "reviewBody": "Great service! The trip from Pune to Sangli was comfortable and relaxing. Highly recommend for anyone traveling to Sangli."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Nina Shah"
      },
      "datePublished": "2024-08-02",
      "reviewBody": "The Cab service to Sangli was very smooth and comfortable. The driver was friendly and the ride was on time. Very satisfied with SHREE Tours & Travels!"
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Pune to Sangli Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5204,  // Pune latitude
      "longitude": 73.8567  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/pune-to-sangli-cab-service"
  },
  "keywords": "Pune to Sangli Taxi, Pune to Sangli Cab Service, Pune to Sangli One-Way Taxi, Pune to Sangli Round Trip Cab, Affordable Pune to Sangli Cab, Private Taxi for Sangli from Pune, Sangli Tour from Pune by Cab, Sangli Cab Hire, Group Travel from Pune to Sangli, Book Pune to Sangli Car, Sangli Cab Booking from Pune, Pune to Sangli Road Trip, Sangli Temple Tour by Cab, Luxury Cab for Pune to Sangli, Affordable Sangli Cab Rental, Pune to Sangli Travel Package, Sangli Sightseeing Cab, Pune to Sangli Weekend Trip"
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune to Sangli Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Cab from Pune to Sangli with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune to Sangli Taxi, Pune to Sangli Cab Service, Pune to Sangli One-Way Taxi, Pune to Sangli Round Trip Cab, Affordable Pune to Sangli Cab, Private Taxi for Sangli from Pune, Sangli Tour from Pune by Cab, Sangli Cab Hire, Group Travel from Pune to Sangli, Book Pune to Sangli Car, Sangli Cab Booking from Pune, Pune to Sangli Road Trip, Sangli Temple Tour by Cab, Luxury Cab for Pune to Sangli, Affordable Sangli Cab Rental, Pune to Sangli Travel Package, Sangli Sightseeing Cab, Pune to Sangli Weekend Trip" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/3.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetosanglicab;